import { ChainContextPayload } from 'rio-core';
import { ChainContext, IntermediateOutput, PromptWithContext } from 'rio-models';

export function payprepareContextPayload(
  prompt: PromptWithContext,
  intermedieteOutputs: IntermediateOutput[],
  currentInputText: string,
): ChainContextPayload | undefined {
  const lastOutput = intermedieteOutputs[intermedieteOutputs.length - 1];

  if (!lastOutput) {
    return undefined; // first prompt of the chain doesn't have the context
  }

  if (prompt.contextType === ChainContext.previousOutput) {
    return {
      original_input: null,
      previous_outputs: [{ output: lastOutput.outputText, prompt_id: lastOutput.promptId }],
    };
  } else if (prompt.contextType === ChainContext.previousOutputAndOriginal) {
    return {
      original_input: currentInputText,
      previous_outputs: [{ output: lastOutput.outputText, prompt_id: lastOutput.promptId }],
    };
  } else if (prompt.contextType === ChainContext.allPreviousOutputsAndOriginal) {
    return {
      original_input: currentInputText,
      previous_outputs: intermedieteOutputs.map(output => ({
        output: output.outputText,
        prompt_id: output.promptId,
      })),
    };
  }
}
